import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDevices = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 24,
	viewBox: "0 -960 960 960",
	width: 24,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M100.001-180.001v-89.998h80v-437.692q0-29.827 21.241-51.067 21.24-21.241 51.067-21.241h567.69V-720h-567.69q-5.385 0-8.847 3.462-3.462 3.462-3.462 8.847v437.692h229.615v89.998H100.001Zm501.153 0q-15.365 0-25.759-10.395Q565-200.79 565-216.155v-379.999q0-15.365 10.395-25.759 10.394-10.394 25.759-10.394H824.23q15.365 0 25.759 10.394t10.394 25.759v379.999q0 15.365-10.394 25.759-10.394 10.395-25.759 10.395H601.154Zm23.845-89.998h175.386v-302.31H624.999v302.31Zm0 0h175.386-175.386Z" })
});
export default SvgDevices;
